"use client"

import { useState } from "react"
import "../styles/contact.css"
import FAQ from "./Faq";

function ContactPage() {
    // State to store form input values
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    // State for form submission status and messages
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    // IMPORTANT: Replace with your actual Google Form's submission URL and entry IDs
    // To find these:
    // 1. Create your Google Form.
    // 2. Go to the live form (not the editor).
    // 3. Right-click on each input field (e.g., Name, Email, Message) and select "Inspect".
    // 4. Look for the 'name' attribute of the input element. It will typically look like 'entry.123456789'.
    // 5. The 'formResponse' URL is usually found by submitting a test entry and checking the network tab,
    //    or by looking at the 'action' attribute of the form tag.
    const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdpvlmgUrjV-ulcRjf-FKuA_cYBelxXM_2QDFL8cqS3RntNEA/formResponse'; // Replace YOUR_FORM_ID

    const ENTRY_NAME = 'entry.85991998';
    const ENTRY_PHONE = 'entry.2063400476';
    // Replace with your Name field's entry ID
    const ENTRY_EMAIL = 'entry.528529595'; // Replace with your Email field's entry ID
    const ENTRY_MESSAGE = 'entry.765561580'; // Replace with your Message field's entry ID

    // Handle input changes and update state
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior
        setLoading(true);
        setStatus('');

        // Create a FormData object to send to Google Forms
        const dataToSend = new FormData();
        dataToSend.append(ENTRY_NAME, formData.name);
        dataToSend.append(ENTRY_PHONE, formData.phone);
        dataToSend.append(ENTRY_EMAIL, formData.email);
        dataToSend.append(ENTRY_MESSAGE, formData.message);

        try {
            // Send data to Google Form using fetch
            const response = await fetch(GOOGLE_FORM_URL, {
                method: 'POST',
                mode: 'no-cors', // Important: Google Forms require 'no-cors' mode
                body: dataToSend,
            });

            // Since 'no-cors' mode is used, we can't check response.ok or status.
            // We assume success if no error is thrown.
            setStatus('Thank you for your submission! We will get back to you soon.');
            setFormData({ name: '', email: '', message: '' }); // Clear the form
        } catch (error) {
            console.error('Error submitting form:', error);
            setStatus('There was an error submitting your form. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div className="main-content-contact">
                <div className="page-header">
                    <div>
                        <h1 className="page-title">Contact Us</h1>
                        <p className="page-subtitle">
                            Have questions or need assistance? Our team is here to help. Reach out to us using any of the methods below.
                        </p>
                    </div>
                </div>

                <div>
                    <div className="row contact-container">
                        <div className="col-md-6 contact-info">
                            <h2 className="contact-info-title">Get in Touch</h2>

                            <div className="contact-detail">
                                <div className="contact-icon">📍</div>
                                <div className="contact-text">
                                    <strong>Our Office</strong>
                                    Haronics Consumer Products LLP
                                    <br />
                                   Sy No 62/4 Bendiganahalli Bidarahalli Hobli
                                    <br />
                                    Landmark - Near Shriram Greenfield apartment
                                    <br />
                                    Bengaluru, Karnataka 560049
                                </div>
                            </div>

                            <div className="contact-detail">
                                <div className="contact-icon">📞</div>
                                <div className="contact-text">
                                    <strong>Phone</strong>
                                    7019272992

                                    <br />
                                    Monday - Friday: 9:00 AM - 6:00 PM
                                </div>
                            </div>

                            <div className="contact-detail">
                                <div className="contact-icon">✉️</div>
                                <div className="contact-text">
                                    <strong>Email</strong>
                                   haronicsindia@gmail.com
                                   <br />
                                   feedbackharonicscpllp@gmail.com
                                </div>
                            </div>

                            <div className="contact-detail">
                                <div className="contact-icon">⏰</div>
                                <div className="contact-text">
                                    <strong>Business Hours</strong>
                                    Monday - Friday: 9:00 AM - 6:00 PM
                                    <br />
                                    Saturday: 10:00 AM - 2:00 PM
                                    <br />
                                    Sunday: Closed
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 contact-form-container">
                            <h2 className="contact-form-title">Send Us a Message</h2>

                            <form className="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name" className="form-label">
                                        Your Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-input"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required

                                    />

                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone" className="form-label">
                                        Phone Number
                                    </label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        className="form-input"
                                        placeholder="Phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        aria-label="Your Phone"

                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email" className="form-label">
                                        Email Address
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="form-input"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        aria-label="Your Email"

                                    />

                                </div>
                                <div className="form-group">
                                    <label htmlFor="subject" className="form-label">
                                        Message
                                    </label>
                                    <textarea
                                        id="message"
                                        className="form-input"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows="5"
                                        required
                                        aria-label="Your Message"
                                    />
                                </div>
                                <div className="sunmitHaro">
                                    <button type="submit" disabled={loading} className="submit-button">
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>

                                    {status && <p className={`status-message ${status.includes('error') ? 'error' : 'success'}`}>{status}</p>}
                                </div>

                            </form>

                        </div>
                    </div>
                    <div className="map-container">
                        <div className="map-placeholder">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d102181.9370793113!2d77.6739687!3d13.0689777!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bae05b9ede09393%3A0x3fe4aefbf02056b!2sSy%20No%2062%2C%204%2C%20Bendiganahalli%2C%20Hobli%2C%20Bidarahalli%2C%20Bengaluru%2C%20Karnataka%20560049!3m2!1d13.0689908!2d77.7563706!5e1!3m2!1sen!2sin!4v1748608269236!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <FAQ />
        </>

    )
}

export default ContactPage
